"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var icons_1 = require("@ant-design/icons");
var antd_1 = require("antd");
var braft_utils_1 = require("braft-utils");
var styled_components_1 = __importDefault(require("styled-components"));
var transifex_1 = require("../../../transifex");
var DEFAULT_SIZE = 16;
var fontSizesItems = [
    {
        key: "32",
        label: transifex_1.TX_SIZE_32,
    },
    {
        key: "24",
        label: transifex_1.TX_SIZE_24,
    },
    {
        key: "16",
        label: transifex_1.TX_SIZE_16,
    },
    {
        key: "12",
        label: transifex_1.TX_SIZE_12,
    },
];
var fontSizes = fontSizesItems.map(function (item) { return +item.key; });
var DropDownView = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 180px;\n  height: 32px;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  padding: 5px 18px 5px 16px;\n  background-color: white;\n"], ["\n  width: 180px;\n  height: 32px;\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #d9d9d9;\n  border-radius: 2px;\n  padding: 5px 18px 5px 16px;\n  background-color: white;\n"])));
var FontSize = function (_a) {
    var _b;
    var editorState = _a.editorState, onFontSizeChange = _a.onFontSizeChange;
    var currentFontSize = react_1.useMemo(function () {
        // eslint-disable-next-line no-restricted-syntax
        for (var _i = 0, fontSizes_1 = fontSizes; _i < fontSizes_1.length; _i++) {
            var fontSize = fontSizes_1[_i];
            if (braft_utils_1.ContentUtils.selectionHasInlineStyle(editorState, "FONTSIZE-" + fontSize)) {
                return fontSize;
            }
        }
        return DEFAULT_SIZE;
    }, [editorState]);
    /**
     * Using Drop down because Antd Select causes
     * The Editor to loose focus and setting font size
     * with no focus is buggy
     */
    return (react_1.default.createElement(antd_1.Dropdown, { trigger: ["click"], overlay: react_1.default.createElement(antd_1.Menu, { selectedKeys: ["" + currentFontSize], onClick: function (opt) { return onFontSizeChange === null || onFontSizeChange === void 0 ? void 0 : onFontSizeChange(opt.key); }, selectable: true, items: fontSizesItems }) },
        react_1.default.createElement(DropDownView, null, (_b = fontSizesItems.find(function (item) { return item.key === "" + currentFontSize; })) === null || _b === void 0 ? void 0 :
            _b.label,
            react_1.default.createElement(icons_1.DownOutlined, null))));
};
exports.default = FontSize;
var templateObject_1;
